import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tiktokCampaignKeys } from '../tiktokCampaign.keys';
import { getTiktokCampaignLeaderboard } from '../tiktokCampaign.service';
/**
 * Queries the TikTok campaign leaderboard
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param tiktokCampaignId The ID of the TikTok campaign
 * @param page The page number to fetch (default: 1)
 * @param pageSize The number of entries per page (default: 20)
 * @param enabled Whether the query should be enabled
 * @example const { data, isLoading } = useTiktokCampaignLeaderboard('my-community', 'campaign-id', 1, 20);
 */
export const useTiktokCampaignLeaderboard = (subdomain, tiktokCampaignId, page = 1, pageSize = 20, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tiktokCampaignKeys.leaderboard(domain, tiktokCampaignId || '', page, pageSize),
        queryFn: async () => {
            if (!tiktokCampaignId) {
                throw new Error('tiktokCampaignId is required');
            }
            return getTiktokCampaignLeaderboard(domain, tiktokCampaignId, page, pageSize);
        },
        enabled: isValidSubdomain(domain) && !!tiktokCampaignId && enabled,
        retry: 1,
    });
};
